// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ConvertStateToMarkdownJs from "./ConvertStateToMarkdown.js";
import * as MediaEntityMapper$PorterinFeature from "../../../media/domain/entity-mappers/MediaEntityMapper.mjs";
import * as SharedEntityMapper$PorterinFeature from "../../../core/domain/entity-mappers/SharedEntityMapper.mjs";

function convertSlateJsonToMarkdown(prim) {
  return ConvertStateToMarkdownJs.convertSlateJsonToMarkdown(prim);
}

function getAreasServed(data) {
  return {
          text: data.title,
          area_list: $$Array.map((function (area) {
                  return {
                          area_name: area.area_name
                        };
                }), data.area_list)
        };
}

function getBestForSending(data) {
  return Js_array.map((function (record) {
                return {
                        category: record.category,
                        image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(record.image),
                        link: Belt_Option.getWithDefault(record.link, "")
                      };
              }), data);
}

function getVehicleInfo(data) {
  var match = data.attributes;
  return {
          fare: match.fare,
          fare_details: Belt_Option.getWithDefault(match.fare_details, ""),
          vehicle_name: match.vehicle_name,
          capacity: match.capacity,
          vehicle_image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(match.vehicle_image),
          best_for_sending: getBestForSending(match.best_for_sending),
          capacity_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(match.capacity_icon),
          url: match.url,
          vehicle_type: match.vehicle_type
        };
}

function getVehicleInfoV2(data, fare, capacity_icon) {
  return {
          fare: fare,
          fare_details: fare,
          vehicle_name: data.data.attributes.vehicle_name,
          capacity: data.data.attributes.capacity,
          vehicle_image: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.data.attributes.vehicle_image),
          best_for_sending: getBestForSending(data.data.attributes.best_for_sending),
          capacity_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(capacity_icon),
          url: data.data.attributes.url,
          vehicle_type: data.data.attributes.vehicle_type
        };
}

function getServiceDescription(data) {
  var model = data.data;
  if (model !== undefined) {
    return {
            text: model.attributes.text,
            sub_text: ConvertStateToMarkdownJs.convertSlateJsonToMarkdown(model.attributes.sub_text)
          };
  } else {
    return {
            text: "",
            sub_text: ""
          };
  }
}

function getInternalLinksSection(data) {
  var title = data.internal_links_title_1;
  var title$1 = data.internal_links_title_2;
  return {
          title: data.title,
          internal_links_title_1: title !== undefined ? title : "",
          internal_links_title_2: title$1 !== undefined ? title$1 : "",
          internal_links_1: $$Array.map((function (link) {
                  return {
                          title: link.title,
                          sub_text: Belt_Option.getWithDefault(link.sub_text, ""),
                          link: link.link
                        };
                }), data.internal_links_1),
          internal_links_2: $$Array.map((function (link) {
                  return {
                          title: link.title,
                          sub_text: Belt_Option.getWithDefault(link.sub_text, ""),
                          link: link.link
                        };
                }), data.internal_links_2)
        };
}

function getInternalLinksSectionV2(model) {
  var data = model.data;
  if (data !== undefined) {
    return {
            text: data.attributes.text,
            link_section: $$Array.map((function (link) {
                    return {
                            text: link.text,
                            links: $$Array.map((function (link) {
                                    return {
                                            title: link.label,
                                            link: link.link
                                          };
                                  }), link.links)
                          };
                  }), data.attributes.link_section)
          };
  } else {
    return {
            text: "",
            link_section: []
          };
  }
}

function getOtherServices(data) {
  return {
          title: data.title,
          services: $$Array.map((function (service) {
                  return {
                          service_name: service.attributes.service_name,
                          service_type: service.attributes.service_type,
                          url: service.attributes.url,
                          service_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(service.attributes.service_icon)
                        };
                }), data.services.data),
          arrow_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.arrow_icon)
        };
}

function getOtherServicesV2(data) {
  if (data !== undefined) {
    return getOtherServices(data.attributes.other_services);
  } else {
    return {
            title: "",
            services: [],
            arrow_icon: {
              path: "",
              alt_text: ""
            }
          };
  }
}

function getPopularOutstation(data) {
  if (data !== undefined) {
    return {
            title: data.title,
            fares: SharedEntityMapper$PorterinFeature.getTextSubtext(data.text_subtext)
          };
  } else {
    return {
            title: "",
            fares: []
          };
  }
}

function getVehicleInventory(data) {
  return {
          title: data.title,
          know_more_cta: SharedEntityMapper$PorterinFeature.getKnowMoreCta(data.know_more_cta),
          vehicle_data: getVehicleInfo(data.vehicle_data.vehicle.data),
          capacity_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(data.capacity_icon)
        };
}

function getVehicles(model) {
  return $$Array.map(getVehicleInfo, model);
}

function getVehiclesV2(model, capacity_icon) {
  if (model !== undefined) {
    return $$Array.map((function (item) {
                  return getVehicleInfoV2(item.vehicle, item.fare, capacity_icon);
                }), model.vehicle);
  } else {
    return [];
  }
}

function getMultiVehicleInventory(model) {
  return {
          title: model.title,
          know_more_cta: SharedEntityMapper$PorterinFeature.getKnowMoreCta(model.know_more_cta),
          light_vehicles: $$Array.map(getVehicleInfo, model.light_vehicles.data),
          heavy_vehicles: $$Array.map(getVehicleInfo, model.heavy_vehicles.data),
          capacity_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(model.capacity_icon),
          light_vehicles_title: model.light_vehicles_title,
          heavy_vehicles_title: model.heavy_vehicles_title
        };
}

function getHeroSection(data, banner) {
  return {
          title: data.title,
          sub_text: data.sub_text,
          know_more_cta: SharedEntityMapper$PorterinFeature.getKnowMoreCta(data.know_more_cta),
          banner_img: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(banner.data.attributes.banner_img),
          banner_img_mobile: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(banner.data.attributes.banner_img_mobile)
        };
}

function getFaqsSection(model) {
  if (model === undefined) {
    return {
            title: "",
            sub_text: "",
            faqs: [],
            toggle_icon: {
              path: "",
              alt_text: ""
            }
          };
  }
  var sub_text = model.attributes.faqs_section.sub_text;
  return {
          title: model.attributes.faqs_section.title,
          sub_text: sub_text !== undefined ? sub_text : "",
          faqs: SharedEntityMapper$PorterinFeature.getFaqs(model.attributes.faqs_section.faqs),
          toggle_icon: MediaEntityMapper$PorterinFeature.getImageFromSingleImage(model.attributes.faqs_section.toggle_icon)
        };
}

function getPopularOutstationV2(data) {
  if (data !== undefined) {
    return {
            title: data.attributes.text,
            fares: $$Array.map((function (item) {
                    return {
                            text: ConvertStateToMarkdownJs.convertSlateJsonToMarkdown(item.text),
                            sub_text: ConvertStateToMarkdownJs.convertSlateJsonToMarkdown(item.sub_text)
                          };
                  }), data.attributes.outstation)
          };
  } else {
    return {
            title: "",
            fares: []
          };
  }
}

function getAreasServedV2(data) {
  var model = data.data;
  if (model !== undefined) {
    return {
            text: model.attributes.text,
            area_list: $$Array.map((function (area) {
                    return {
                            area_name: area.area_name
                          };
                  }), model.attributes.area_list)
          };
  } else {
    return {
            text: "",
            area_list: []
          };
  }
}

function getPointersV2(data) {
  if (data !== undefined) {
    return {
            text: data.attributes.features.title,
            pointer: $$Array.map((function (item) {
                    return {
                            text: item.title,
                            sub_text: item.sub_text,
                            icon: {
                              path: "",
                              alt_text: "string"
                            }
                          };
                  }), data.attributes.features.feature_list)
          };
  } else {
    return {
            text: "",
            pointer: []
          };
  }
}

export {
  convertSlateJsonToMarkdown ,
  getAreasServed ,
  getBestForSending ,
  getVehicleInfo ,
  getVehicleInfoV2 ,
  getServiceDescription ,
  getInternalLinksSection ,
  getInternalLinksSectionV2 ,
  getOtherServices ,
  getOtherServicesV2 ,
  getPopularOutstation ,
  getVehicleInventory ,
  getVehicles ,
  getVehiclesV2 ,
  getMultiVehicleInventory ,
  getHeroSection ,
  getFaqsSection ,
  getPopularOutstationV2 ,
  getAreasServedV2 ,
  getPointersV2 ,
}
/* ./ConvertStateToMarkdown.js Not a pure module */
